import React, {useRef, useState} from 'react';
import {FileUpload} from 'primereact/fileupload';
import PropTypes from 'prop-types';
import {t} from 'i18next';
import FileUploadService from '../services/FileUploadService';
import StringUtils from '../utils/StringUtils';
import {Button} from 'primereact/button';
import UrlUtils from '../utils/UrlUtils';

export const FileUploadComponent = (props) => {
    const {
        viewMode,
        srcUrl,
        required,
        reqiredLabel,
        validator,
        errorMessage,
        handleAdd,
        initAttachment,
        mode,
        handleRemove,
        className,
        maxFileSize,
        fileSizeToTranslation,
        id,
    } = props;

    const [selectedFile, setSelectedFile] = useState(null);
    const [attachment, setAttachment] = useState(initAttachment);
    const fileUploadRef = useRef(null);
    const fileUploadService = new FileUploadService();

    const onSelect = (e) => {
        const file = e.files[0];
        setSelectedFile(file);
        uploadHandler(file);
    };

    const onClear = () => {
        setSelectedFile(null);
        handleRemove();
    };

    const preRemove = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setAttachment(null);
        handleRemove();
    };
    const uploadHandler = async (file) => {
        const formData = new FormData();
        if (file) {
            formData.append('file', file);

            fileUploadService
                .uploadAttachemnt(formData)
                .then((uploadedFile) => {
                    handleAdd(uploadedFile);
                })
                .catch((err) => {
                    errorMessage(err.message);
                });
        }
    };
    const handleDownload = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (!srcUrl) return;
        const link = document.createElement('a');
        link.href = srcUrl;
        if(StringUtils.isBlank(attachment?.id)) {
            link.href = fileUploadService.fullPath() + "/" + attachment.uuid + "?token=" + UrlUtils.getTokenFromUrl(srcUrl)
        }
        link.download = '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
   
    return (attachment)  || viewMode === 'VIEW' ? (
        <div className='col-lg-12'>
            {!StringUtils.isBlank(attachment) && (
                <React.Fragment>
                    <Button
                        label={attachment.fileName}
                        icon=''
                        className='p-button-outlined p-button-success'
                        style={{marginRight: '10px'}}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                    />
                    <Button
                        label='Pobierz załącznik'
                        icon='pi pi-download'
                        className='p-button-outlined p-button-primary'
                        style={{marginRight: '10px'}}
                        onClick={handleDownload}
                    />
                </React.Fragment>
            )}
            {viewMode !== 'VIEW' && attachment && (
                <Button
                    label='Usuń załącznik'
                    icon='mdi mdi-trash-can'
                    className='p-button-outlined p-button-danger'
                    style={{marginRight: '10px'}}
                    onClick={preRemove}
                />
            )}
        </div>
    ) : (
        <React.Fragment>
            <FileUpload
                id={id}
                ref={fileUploadRef}
                uploadLabel={t('file.upload')}
                chooseLabel={mode === 'basic' ? 'Załącznik' : t('file.choose')}
                cancelLabel={t('file.cancel')}
                multiple={false}
                customUpload
                uploadOptions={{className: 'hidden'}}
                cancelOptions={{className: 'hidden'}}
                onSelect={onSelect}
                onRemove={onClear}
                onClear={onClear}
                disabled={viewMode === 'VIEW'}
                accept='*'
                className={`fileupload-component ${className}`}
                maxFileSize={maxFileSize}
                invalidFileSizeMessageSummary={t('global.invalidFileSizeSummary')}
                invalidFileSizeMessageDetail={t('global.invalidFileSizeDetails') + fileSizeToTranslation}
            />

            {required && validator?.messagesShown && !selectedFile && (
                <div aria-live='assertive' style={{color: 'tomato', fontSize: '13px'}}>
                    {reqiredLabel}
                </div>
            )}
        </React.Fragment>
    );
};

FileUploadComponent.defaultProps = {
    required: false,
    reqiredLabel: 'Pole wymagane',
    id: 'file-upload',
    mode: 'basic',
};

FileUploadComponent.propTypes = {
    validator: PropTypes.object,
    required: PropTypes.bool,
    id: PropTypes.string,
    mode: PropTypes.string,
    reqiredLabel: PropTypes.string,
};

export default FileUploadComponent;
